/**
 * The shared `md` breakpoint is 26em (416px), which falls inside the range of
 * common phone widths, so handsets pick up the horizontal desktop layout. The
 * finder switches at 30em (480px) instead. Kept local to this feature so the
 * shared breakpoint stays put for the rest of the app.
 */
export const FINDER_WIDE = "@media (min-width: 30em)";

/** Mirrors the theme's `lg` breakpoint (48em / 768px). */
export const FINDER_DESKTOP = "@media (min-width: 48em)";
